export default {
  pt: {
    pageTitle: "Seguro",
    mainTitle: "Escolha seu plano",
    accidentOrBreakLabel: "Acidente ou quebra",
    entryText: "Entrada de {value} +",
    installmentsText: "até {installments} x {value}",
    insuranceNote: "* Seguro por 1 ano com reposição da bicicleta ou outra similar.",
    offer: "Oferta",
    contractButton: "Contratar",
    detailsButton: "Detalhes",
    continueButton: "Continuar",
    upgradeTitle: "Upgrade de quebra",
    upgradeDescription:
      "Aproveite a oportunidade e contrate a cobertura de <b>danos acidentais</b> para sua bike.",
    didYouKnowTitle: "💬 Você sabia?",
    didYouKnowItem1:
      "Metade das indenizações do seguro são para pagar quebra durante o pedal ou transporte da bike.",
    didYouKnowItem2: "Não corra riscos desnecessários, garanta sua tranquilidade hoje mesmo!",
    upgradeLabel: "UPGRADE DE QUEBRA",
    upgradeAddText: "Adicione ao seu plano <b>por apenas:</b>",
    upgradeNowButton: "Fazer upgrade agora!",
    dismissButton: "Dispensar",
    pendingApprovalBanner:
      '<span class="pending-approval-highlight text-on-surface">O valor exibido é uma simulação e está sujeito à mudança:</span> o valor real do seguro depende do valor de novo do modelo.',
    talkToConsultantButton: "Falar com consultor",
    talkToConsultantWhatsAppText:
      "Olá! Não encontrei minha bike no catálogo e simulei os valores do seguro. Pode me ajudar a confirmar os detalhes?",
    outOfHoursTitle: "Estamos fora do horário de atendimento",
    outOfHoursDescription:
      "<u>Nosso horário de atendimento é de {weekdays}, das {start} às {end}.</u> Mesmo assim, você pode enviar sua mensagem pelo WhatsApp. Vamos entrar em contato assim que possível.",
    outOfHoursGoToWhatsApp: "Ir para o WhatsApp",
    outOfHoursCancel: "Cancelar",
  },

  en: {
    pageTitle: "Insurance",
    mainTitle: "Choose your plan",
    accidentOrBreakLabel: "Accident or break",
    entryText: "Entry of {value} +",
    installmentsText: "up to {installments} x {value}",
    insuranceNote: "* Insurance for 1 year with bicycle replacement or similar.",
    offer: "Offer",
    contractButton: "Contract",
    detailsButton: "Details",
    continueButton: "Continue",
    upgradeTitle: "Break upgrade",
    upgradeDescription:
      "Take advantage of the opportunity and contract <b>accidental damage</b> coverage for your bike.",
    didYouKnowTitle: "💬 Did you know?",
    didYouKnowItem1:
      "Half of insurance claims are to pay for breaks during pedaling or bike transport.",
    didYouKnowItem2: "Don't take unnecessary risks, ensure your peace of mind today!",
    upgradeLabel: "BREAK UPGRADE",
    upgradeAddText: "Add to your plan <b>for only:</b>",
    upgradeNowButton: "Upgrade now!",
    dismissButton: "Dismiss",
    pendingApprovalBanner:
      "Your bike hasn't been validated by a consultant yet. The displayed value is a simulation — the actual insurance value depends on your bike's invoice price and may differ from what's shown here.",
    talkToConsultantButton: "Talk to a consultant",
    talkToConsultantWhatsAppText:
      "Hi! I couldn't find my bike in the catalog and simulated the insurance values. Can you help me confirm the details?",
    outOfHoursTitle: "We're outside business hours",
    outOfHoursDescription:
      "<u>Our support hours are {weekdays}, from {start} to {end}.</u> You can still send your message on WhatsApp. We'll get back to you as soon as possible.",
    outOfHoursGoToWhatsApp: "Go to WhatsApp",
    outOfHoursCancel: "Cancel",
  },
};
